import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import Border from '../../img/products/border.png';
import { colors } from '../../Theme/tokens';

const TimelineView = ({ timeline }) => {
    
  return (
    <Box sx={{ width: "100%", display: "flex", alignItems: "center", mb:"10px" }}>
      {timeline.map((item, index) => (
        <React.Fragment key={index}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center", flex: 1 }}>
            <Typography variant='h6' color='Grey' sx={{  color: colors.text.gray }}>
              {item.title}
            </Typography>
            <Typography sx={{ padding: "5px 15px", borderRadius: "100%", backgroundColor: colors.primary.main, width: "fit-content", color: "white" }}>
              {index + 1}
            </Typography>
            <Typography variant='h6' sx={{ color: colors.text.primary, fontWeight: "500", letterSpacing: "2%" }}>
              {item.deadline ? moment(item.deadline).format('MMM DD, YYYY, HH:MM') : ""}
            </Typography>
            {item.deadline && (
              <Typography variant='h6' sx={{ color: colors.text.gray, fontWeight: "500", letterSpacing: "2%" }}>
                {/* {`(UTC${item.deadline.slice(-6)})`} */}
                 {`(UTC${item?.deadline?.match(/([+-]\d{2}:\d{2})$/)?.[1] || "+08:00"})`}
              </Typography>
            )}
          </Box>
          {index < timeline.length - 1 && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", justifyContent: "center", alignItems: "center", flex: 1 }}>
              {timeline[index + 1]?.connectorText? (
                <Typography variant='h6' color='Grey' sx={{ color: colors.primary.main }}>
                  {timeline[index + 1].connectorText}
                </Typography>
              ) : (<Typography variant='h6' color='Grey' sx={{minWidth:"94px", color: colors.primary.main, visibility:"hidden" }}>
                {timeline[index + 1].connectorText}
              </Typography>)}
              <Box component='img' src={Border} sx={{ height: "0", width: "100%",

                mt: !timeline[index + 1]?.connectorText ? "20px" : "0", 
               }} />
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default TimelineView;
